
export enum MemberInviteStatus {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    DENIED = 'denied',
    REVOKED = 'revoked' 
}

